import axios from "../utils/request";

// const menuList = (option, token) => {
//     return axios.get(`/menu/categorielist`, { ...option }, JSON.parse(sessionStorage.getItem("token")).session.token);
// };
const menuList = (option) => { return axios.get(`/menu/categorielist`, { ...option }); };

export { menuList };